/* eslint-disable camelcase */
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';

import './markdown/style.scss';
import createChartLinePlugin from './markdown/createChartLinePlugin';
import createChartBarPlugin from './markdown/createChartBarPlugin';
import createChartPiePlugin from './markdown/createChartPiePlugin';
import createChartTablePlugin from './markdown/createChartTablePlugin';
import createModelCOPPlugin from './markdown/createModelCOPPlugin';
import createModelDispatchPlugin from './markdown/createModelDispatchPlugin';
import createModelEmergencyPlugin from './markdown/createModelEmergencyPlugin';
import createPlugin_flow_prediction from './markdown/createPlugin_flow_prediction';
import createPlugin_flow_simulation from './markdown/createPlugin_flow_simulation';
// 智能运维插件
import createChartAiopsPlugin from './markdown/createChartAiopsPlugin';

import hljs from 'highlight.js';

import * as echartsMod from 'echarts';
// import 'echarts-gl';

import dayjs from 'dayjs';

const echarts = Object.assign({}, echartsMod);

const install = (Vue, options) => {
    VMdPreview.use(githubTheme, { Hljs: hljs });
    VMdPreview.use(createChartLinePlugin());
    VMdPreview.use(createChartBarPlugin());
    VMdPreview.use(createChartPiePlugin());
    VMdPreview.use(createChartTablePlugin());
    VMdPreview.use(createModelCOPPlugin());
    VMdPreview.use(createModelDispatchPlugin());
    VMdPreview.use(createModelEmergencyPlugin());
    VMdPreview.use(createPlugin_flow_prediction());
    VMdPreview.use(createPlugin_flow_simulation());
    VMdPreview.use(createChartAiopsPlugin());

    Vue.use(VMdPreview);

    Vue.prototype.$echarts = echarts; // 使用 ECharts 的静态方法
    Vue.prototype.$dayjs = dayjs;
};

export default {
    install
};
